
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TableRow, TableCell } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Pencil, MoreHorizontal } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { DeleteButton } from "@/components/common/DeleteButton";
import { Job } from './types';
import { format, parseISO } from 'date-fns';

interface JobTableRowProps {
  job: Job;
}

export const JobTableRow: React.FC<JobTableRowProps> = ({ job }) => {
  const navigate = useNavigate();

  return (
    <TableRow 
      className="hover:bg-muted/50"
    >
      <TableCell 
        onClick={() => navigate(`/jobs/${job.id}`)} 
        className="font-medium cursor-pointer hover:underline"
      >
        {job.title}
      </TableCell>
      <TableCell>{job.company || job.client_name || 'N/A'}</TableCell>
      <TableCell>{job.location}</TableCell>
      <TableCell>
        <Badge variant={
          job.status === 'open' ? 'default' :
          job.status === 'closed' ? 'destructive' :
          job.status === 'on-hold' ? 'secondary' :
          'outline'
        }>
          {job.status?.replace('-', ' ')}
        </Badge>
      </TableCell>
      <TableCell>{job.employment_type || 'N/A'}</TableCell>
      <TableCell>{job.posted_date ? format(parseISO(job.posted_date), 'MMM d, yyyy') : 'N/A'}</TableCell>
      <TableCell>{job.applicants ?? 0}</TableCell>
      <TableCell>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="sm">
              <MoreHorizontal className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem onClick={() => navigate(`/jobs/${job.id}#overview-edit`)}>
              <Pencil className="h-4 w-4 mr-2" />
              Edit Job
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem asChild>
              <DeleteButton
                entityType="job"
                entityId={job.id}
                entityName={job.title || 'Untitled Job'}
                variant="ghost"
                size="sm"
                className="w-full justify-start text-destructive hover:text-destructive"
              >
                Delete Job
              </DeleteButton>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </TableCell>
    </TableRow>
  );
};
